import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../application/config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect,useState } from 'react';
import './Form.css';
import sleep from 'sleep-promise';
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";

function Form() {
    const profileFilter = chooseProfileFilter();
    const { id } = useParams();
    const [form,setForm] = useState();
    const [formContent,setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;
    const path = 'governanceroom/departments';
    const incrementInput = (profileFilter.governance_room_client_city_id || Object.keys(profileFilter).length === 0
    ) ? 1 : 0;

    const paths = {
        endpointSave: `${endpointBackend}${path}/save`,
        endpointGetById: `${endpointBackend}${path}/getById`,
        urlGoBack: `/${path}/list`,
        pathView: `/${path}/view`
    }

    const labels = {
        labelTitleAdd: "Nova Departamento",
        labelTitleEdit: "Editar Departamento",
        labelTitleView: 'Visualizar Departamento'
    }

    const hiddenValues = {}

    if (profileFilter.governance_room_secretariat_id) {
        hiddenValues.governance_room_secretariat_id = profileFilter.governance_room_secretariat_id
    }

    const clearValues = (values, keys = []) => {
        if(keys.length > 0){
            for (const key of keys) {
                if(key === 'categories' || key === 'file_types'){
                    values[key] = [];
                    continue;
                }
                values[key] = '';
            }
        }
        return values;
    };

    const getForm = (values) => {

        let form = {
            validateOnChange: false,
            hiddenValues: hiddenValues,
            fields: [
                !profileFilter.governance_room_client_city_id && {
                    name: 'governance_room_client_city_id',
                    type: 'select',
                    label: 'Município',
                    options: [],
                    optionsEndpoint: {
                      endpoint: endpointBackend + 'governanceroom/clientscities/getall',
                      label: 'company_city_name',
                      value: 'id',
                      params: {
                        filter: {
                            ...profileFilter
                        }
                      }
                    },
                    handleChange: async (element,field,values) => {
                        values = clearValues(values, [
                            'governance_room_secretariat_id',
                            'categories',
                            'file_types',
                        ]);
                        let form = getForm(values);
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                        <CustomFormContainer 
                            form = {form}
                            content = {<CustomForm form={form}/>}
                        />)
                    },
                    validations: {
                      required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'governance_room_secretariat_id',
                    type: 'select',
                    label: 'Secretaria',
                    options: [],
                    optionsEndpoint: {
                        endpoint: endpointBackend + 'governanceroom/secretariats/getall',
                        label: 'instance_secretariat_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                governance_room_client_city_id: profileFilter.governance_room_client_city_id ? profileFilter.governance_room_client_city_id : values.governance_room_client_city_id
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'title_department',
                    type: 'text',
                    label: 'Nome Departamento',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'categories',
                    type: 'multiselect',
                    options: [],
                    optionsEndpoint: {
                      endpoint: config.endpoints.backend + 'governanceroom/filecategories/getall',
                      label: 'file_category',
                      value: 'id',
                    },
                    label: 'Categorias',
                    validations: {
                      required: true
                    },
                    handleChange: async (element,field,values) => {
                        const verifyCategories = values.categories.length === 0;
                        values.file_types = verifyCategories ? [] : values.file_types; 
                        let form = getForm(values);
                        form.fields[3 + incrementInput].autoFocus = verifyCategories;

                        const filesTypes = await Fetch.post(config.endpoints.backend + 'governanceroom/filetypes/getall', {
                            filter: {
                                where: {
                                    categories: values.categories
                                }
                            }
                        });

                        values.file_types = values.file_types.filter(fileTypeId =>
                            filesTypes.some(fileType => fileType.id === fileTypeId)
                        );
                        
                        setForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                        <CustomFormContainer 
                            form = {form}
                            content = {<CustomForm form={form}/>}
                        />)
                    },
                    columnSize: 12
                },     
                {
                    name: 'file_types',
                    type: 'multiselect',
                    readOnly: values.categories.length > 0 ? false : true,
                    options: [],
                    optionsEndpoint: {
                      endpoint: config.endpoints.backend + 'governanceroom/filetypes/getall',
                      label: 'file_type',
                      value: 'id',
                      params: {
                        filter: {
                            where: {
                                categories: values.categories
                            }
                        }
                      }
                    },
                    label: 'Tipos de Arquivo',
                    validations: {
                      required: true
                    },
                    columnSize: 12
                },     
            ],
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            values.categories = [];
            if (id) {
                values = await Fetch.post(paths.endpointGetById,{id:id})
            }
            const form = getForm(values);
            if(id){
                form.fields[3 + incrementInput].readOnly = values.categories.length === 0;
            }
            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    },[])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
